// copied from VPC.

import { IRequest } from './IRequest';
import { IServer } from './IServer';

export type RequestHeaders = {
  [name: string]: string;
};

export class Request<TParams, TResult> implements IRequest<TParams, TResult> {
  public method: string;
  public params: TParams;

  constructor(method: string, params: TParams, public headers?: RequestHeaders) {
    this.method = method;
    this.params = params;
  }

  public send(server: IServer): Promise<TResult> {
    return server.sendRequest<TParams, TResult>(this);
  }
}
